import React from "react";
import { MdOutlineDvr, MdOutlineAdUnits, MdOutlineSummarize, MdPlayCircleOutline, MdOutlineSchool } from 'react-icons/md';


const sidebarItems: any[] = [
    // {
    //     icon: React.createElement(MdOutlineSchool, {}),
    //     classSelected: "bg-courses",
    //     name: "Cursos",
    //     permission: "Cursos",
    //     route: "/courses",
    //     link: "",
    //     level: 1,
    //     children: [],
    // },
    {
        icon: React.createElement(MdOutlineDvr, {}),
        classSelected: "bg-disciplines",
        name: "Disciplinas",
        permission: "Disciplinas",
        route: "/disciplines",
        link: "",
        level: 1,
        children: [],
    },
    {
        icon: React.createElement(MdOutlineAdUnits, {}),
        classSelected: "bg-unities",
        name: "Unidades",
        permission: "Unidades",
        route: "/unity",
        link: "",
        level: 1,
        children: [],
    },
    {
        icon: React.createElement(MdPlayCircleOutline, {}),
        classSelected: "bg-objects",
        name: "Objetos",
        permission: "Objetos",
        route: "/objects",
        link: "",
        level: 1,
        children: [],
    },
];

export default sidebarItems;
